const routeMain = () => "/architecture";

export default routeMain;
